<template>
  <customers-page
    v-if="display"
    :title="title"
    :filter-meta="filterMeta"
    :reseller-id="resellerId"
  />
</template>

<script>

import { mapActions } from 'vuex'
import CustomersPage from '@/components/pages/Admin/Customer/CustomersPage'

export default {
  components: {
    CustomersPage
  },

  props: {
    reseller: {
      type: Object,
      required: false
    },

    resellerId: {
      type: Number,
      required: false
    }
  },

  computed: {
    title () {
      return `Återförsäljare ${this.resellerData.name} - kunder`
    }
  },

  data () {
    return {
      display: false,
      resellerData: null, // Don't mutate prop
      filterMeta: [{
        fieldId: 'name',
        type: 'string',
        label: 'Kund'
      },
      {
        fieldId: 'organizationNumber',
        type: 'string',
        label: 'Organisationsnummer'
      }
      ]
    }
  },

  methods: {
    ...mapActions('resellers', ['getById'])
  },

  created () {
    if (!this.resellerId && !this.reseller) {
      console.error('You need to set either resellerId or reseller prop')
    }

    const promises = []

    if (!this.reseller) {
      promises.push(this.getById(this.resellerId).then(data => {
        this.resellerData = data.result
      }))
    }
    else {
      this.resellerData = this.reseller
    }

    Promise.all(promises).then(() => {
      this.display = true
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Admin/Customer/ResellerCustomersPage.vue